export default __webpack_public_path__ + "static/media/storageUnit1-afterB-768w.a616885f.webp";